import { setter } from "./setter";
import { isDisabled } from "../utils";

export default {
  props: {
    formContext: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    emitFieldChange(component, value) {
      if (this.disabled) {
        return;
      }

      var item = this.item;
      if (item === undefined || item === null) {
        item = {};
      }

      setter(this, item, this.field.code, value);

      console.log(`[${new Date().toISOString()}] ${component} @change event:`, {
        component,
        fieldCode: this.field.code,
        fieldType: this.field.field_type,
        value,
        item,
      });

      this.$emit("change", item);
    },
  },
  computed: {
    is_disabled() {
      if (this.formContext && this.formContext.isLocked) {
        return true; // entire form is locked
      }

      // Check workflow field controls
      if (
        this.workflow_field_controls &&
        this.workflow_field_controls.disabled !== undefined
      ) {
        return this.workflow_field_controls.disabled;
      }

      // Then check standard disabled logic
      if (this.field && this.field.code) {
        return isDisabled(this.item, this.field.code, this.disabled);
      }

      return this.disabled;
    },
    workflowFields() {
      // Extract workflowFields from formContext
      if (this.formContext && this.formContext.workflowFields) {
        return this.formContext.workflowFields.fields || {};
      }
      return {};
    },
    workflow_field_controls() {
      // Extract workflow field controls for this specific field
      // Check __all__ first, then specific field by name
      if (!this.field || !this.field.code) {
        return {};
      }

      const controls = {};

      // First, apply __all__ controls if they exist
      if (this.workflowFields && this.workflowFields.__all__) {
        Object.assign(controls, this.workflowFields.__all__);
      }

      // Then, apply field-specific controls (these override __all__)
      if (this.workflowFields && this.workflowFields[this.field.code]) {
        Object.assign(controls, this.workflowFields[this.field.code]);
      }

      return controls;
    },
    nested_workflow_fields() {
      // Get workflow fields for nested child fields
      if (this.workflow_field_controls && this.workflow_field_controls.fields) {
        return this.workflow_field_controls.fields;
      }
      return {};
    },
    nestedFormContext() {
      // Create formContext for nested children with updated workflowFields
      return {
        ...this.formContext,
        workflowFields: this.nested_workflow_fields,
      };
    },
    is_visible() {
      if (this.workflow_field_controls && this.workflow_field_controls.visible !== undefined) {
        return this.workflow_field_controls.visible;
      }

      return true;
    },
    field_visible() {
      return this.is_visible;
    },
    field_label() {
      if (this.workflow_field_controls && this.workflow_field_controls.label !== undefined) {
        return this.workflow_field_controls.label;
      }

      if (this.field && this.field.name) {
        return this.field.name;
      }

      return "";
    },
  },
};
